<script>
import {mapGetters} from "vuex"
export default {
  render() {
    return this.$scopedSlots.default({
      list: this.currentLocationUsers
    })
  },
  
  props: {
    model: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapGetters({
      cbrUsers: 'cbrUser/items',
      defaultCBRUser: 'cbrUser/default'
    }),

    currentLocationUsers() {
      let location = this.model.course.city
      if(!location) return []
      return this.cbrUsers.filter(item => item.courseLocations.includes(location))
    },
  }
}
</script>